/* Modal de captação de leads (sections/conso-lead-modal.liquid).

   Estado no localStorage (por navegador):
   - conso_lead_cupom     {codigo, rotulo, modo, em}: já se cadastrou. Não abre mais;
                          a aba lateral vira "Meu cupom" e mostra o resultado.
   - conso_lead_aberturas {dia, n}: aberturas automáticas hoje (limite da section).
   - conso_lead_visto     '1': já viu a modal; a aba lateral aparece em toda visita.
   - conso_membro         {em}: membro da Área de membros neste navegador (gravado pela
                          conso-area-shell e pelo cadastro). Não abre nem mostra a aba.
   Carrinho: atributos _conso_roleta ('1' = passou pela roleta) e _conso_roleta_premio
   (rótulo do prêmio), gravados no cadastro e remarcados 1x por sessão (sessionStorage
   conso_roleta_carrinho). Até 29/10/2026 eram _conso_lead (roleta|cupom) e
   _conso_lead_premio: pedidos antigos têm esses nomes. O modo cupom não marca.

   Roleta: o sorteio é aqui, pela chance dos blocos. Cada prêmio ocupa 2 fatias
   opostas (fatia k e k + P). O envio do lead vem antes do giro: se o app falhar (5xx
   ou rede), o giro segue — o cupom é genérico e perder o visitante é pior. */

(() => {
  if (customElements.get('conso-lead-modal')) return;

  const CHAVE_CUPOM = 'conso_lead_cupom';
  const CHAVE_ABERTURAS = 'conso_lead_aberturas';
  const CHAVE_VISTO = 'conso_lead_visto';
  const CHAVE_MEMBRO = 'conso_membro';
  const CHAVE_SESSAO_CARRINHO = 'conso_roleta_carrinho';
  const GIRO_MS = 5000;

  const ler = (chave) => {
    try {
      return JSON.parse(localStorage.getItem(chave) || 'null');
    } catch (e) {
      return null;
    }
  };
  const gravar = (chave, valor) => {
    try {
      localStorage.setItem(chave, JSON.stringify(valor));
    } catch (e) {}
  };
  const hoje = () => new Date().toLocaleDateString('sv-SE');
  const dl = (dados) => (window.dataLayer = window.dataLayer || []).push(dados);

  class ConsoLeadModal extends HTMLElement {
    connectedCallback() {
      try {
        this.config = JSON.parse(this.querySelector('[data-lead-config]').textContent);
      } catch (e) {
        console.warn('[conso-lead-modal] config inválida', e);
        return;
      }
      this.modo = this.dataset.modo === 'cupom' ? 'cupom' : 'roleta';
      this.editor = this.hasAttribute('data-editor');
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-lead-form]');
      this.cta = this.querySelector('[data-lead-cta]');
      this.erroGeral = this.querySelector('[data-lead-erro-geral]');
      this.aba = this.querySelector('[data-lead-aba]');
      this.girando = false;
      this.rotacao = 0;

      if (this.modo === 'roleta') this.montarRoda();
      this.ligarEventos();

      if (this.editor) {
        this.abrir('editor');
        return;
      }

      const cupom = ler(CHAVE_CUPOM);
      if (ler(CHAVE_MEMBRO)) {
        // Membro não vê roleta nem aba. Só mantém a marca do cupom no carrinho.
        if (cupom && sessionStorage.getItem(CHAVE_SESSAO_CARRINHO) !== '1') this.marcarCarrinho(cupom);
        return;
      }
      if (cupom) {
        this.mostrarResultado(cupom, false);
        this.mostrarAba(true);
        // Carrinho expira/troca (ex.: depois de uma compra): remarca 1x por sessão.
        if (sessionStorage.getItem(CHAVE_SESSAO_CARRINHO) !== '1') this.marcarCarrinho(cupom);
        return;
      }
      if (ler(CHAVE_VISTO)) this.mostrarAba(false);

      const ab = ler(CHAVE_ABERTURAS);
      const n = ab && ab.dia === hoje() ? ab.n : 0;
      const limite = parseInt(this.dataset.limite, 10) || 2;
      if (n >= limite) return;

      const atraso = (parseInt(this.dataset.atraso, 10) || 0) * 1000;
      setTimeout(() => {
        // Outra modal aberta (promo do carrinho, brinde): não empilha.
        if (document.querySelector('dialog[open]')) return;
        gravar(CHAVE_ABERTURAS, { dia: hoje(), n: n + 1 });
        this.abrir('auto');
      }, atraso);
    }

    // --- Roleta -------------------------------------------------------------

    montarRoda() {
      const premios = this.config.premios || [];
      const alvo = this.querySelector('[data-lead-roda]');
      if (!alvo || premios.length < 2) return;

      const P = premios.length;
      const N = P * 2;
      const fatia = 360 / N;
      const R = 100;
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '-100 -100 200 200');
      svg.setAttribute('aria-hidden', 'true');

      const ponto = (graus, raio) => {
        const rad = (graus * Math.PI) / 180;
        return [raio * Math.cos(rad), raio * Math.sin(rad)];
      };

      // Ângulo 0 = 3 horas; positivo = horário (o y do SVG cresce pra baixo).
      for (let i = 0; i < N; i++) {
        const premio = premios[i % P];
        const ini = i * fatia;
        const fim = ini + fatia;
        const [x1, y1] = ponto(ini, R);
        const [x2, y2] = ponto(fim, R);
        const escura = i % 2 === 0;

        const path = document.createElementNS(ns, 'path');
        path.setAttribute('d', `M0 0 L${x1.toFixed(3)} ${y1.toFixed(3)} A${R} ${R} 0 0 1 ${x2.toFixed(3)} ${y2.toFixed(3)} Z`);
        path.setAttribute('class', escura ? 'conso-lead__fatia-a' : 'conso-lead__fatia-b');
        svg.appendChild(path);

        const meio = ini + fatia / 2;
        const texto = document.createElementNS(ns, 'text');
        texto.setAttribute('x', '60');
        texto.setAttribute('y', '0');
        texto.setAttribute('transform', `rotate(${meio})`);
        texto.setAttribute('class', escura ? 'conso-lead__rotulo-a' : 'conso-lead__rotulo-b');
        texto.textContent = premio.rotulo;
        svg.appendChild(texto);
      }

      const miolo = document.createElementNS(ns, 'circle');
      miolo.setAttribute('r', '9');
      miolo.setAttribute('class', 'conso-lead__miolo');
      svg.appendChild(miolo);

      this.svgRoda = svg;
      this.fatia = fatia;
      alvo.appendChild(svg);
    }

    sortear() {
      const premios = this.config.premios || [];
      const total = premios.reduce((s, p) => s + Math.max(0, p.chance || 0), 0);
      if (total <= 0) {
        const idx = Math.max(0, premios.findIndex((p) => p.codigo));
        return idx;
      }
      let r = Math.random() * total;
      for (let i = 0; i < premios.length; i++) {
        r -= Math.max(0, premios[i].chance || 0);
        if (r < 0) return i;
      }
      return premios.length - 1;
    }

    // Ponteiro: à direita (0°) no desktop, embaixo (90°) no mobile — ver o CSS.
    anguloPonteiro() {
      return window.matchMedia('(min-width: 750px)').matches ? 0 : 90;
    }

    girar(indice) {
      return new Promise((resolve) => {
        const P = (this.config.premios || []).length;
        if (!this.svgRoda || !P) return resolve();

        const fatiaIdx = indice + (Math.random() < 0.5 ? 0 : P);
        const centro = (fatiaIdx + 0.5) * this.fatia;
        const folga = (Math.random() - 0.5) * this.fatia * 0.6;
        const destino = (((this.anguloPonteiro() - centro - folga) % 360) + 360) % 360;
        const voltas = 6 * 360;
        const atual = ((this.rotacao % 360) + 360) % 360;
        this.rotacao += voltas + ((destino - atual + 360) % 360);

        const reduzir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const roda = this.querySelector('[data-lead-roda]');
        roda.style.transition = reduzir ? 'none' : `transform ${GIRO_MS}ms cubic-bezier(0.12, 0.7, 0.12, 1)`;
        roda.style.transform = `rotate(${this.rotacao}deg)`;
        setTimeout(resolve, reduzir ? 300 : GIRO_MS + 200);
      });
    }

    // --- Modal --------------------------------------------------------------

    ligarEventos() {
      this.querySelectorAll('[data-lead-fechar]').forEach((b) =>
        b.addEventListener('click', () => this.fechar()),
      );
      // Clique fora da caixa = no backdrop do <dialog>.
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.fechar();
      });
      // Tab/Shift+Tab tratados aqui: apps de popup (o EcomSend) prendem o Tab no
      // document pra modal deles, e com a nossa aberta o foco não andava. Eles
      // respeitam defaultPrevented, e este listener roda antes (está no dialog).
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey) return;
        const focaveis = Array.from(
          this.dialog.querySelectorAll('input, button, a[href], select, textarea, [tabindex]'),
        ).filter((el) => el.tabIndex >= 0 && !el.disabled && el.getClientRects().length > 0);
        if (!focaveis.length) return;
        const atual = focaveis.indexOf(document.activeElement);
        const prox = e.shiftKey
          ? (atual <= 0 ? focaveis.length : atual) - 1
          : (atual + 1) % focaveis.length;
        e.preventDefault();
        focaveis[prox].focus();
      });
      this.dialog.addEventListener('cancel', (e) => {
        if (this.girando) e.preventDefault();
        else {
          e.preventDefault();
          this.fechar();
        }
      });
      this.aba.addEventListener('click', () => this.abrir('aba'));
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.enviar();
      });
      this.form.addEventListener('input', (e) => {
        const nome = e.target.name;
        if (nome === 'telefone') e.target.value = this.mascaraTelefone(e.target.value);
        if (nome === 'nascimento') e.target.value = this.mascaraData(e.target.value);
        this.erro(nome, '');
      });
      const copiar = this.querySelector('[data-lead-copiar]');
      copiar.addEventListener('click', () => this.copiar(copiar));
    }

    abrir(origem) {
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.aba.hidden = true;
      if (!this.editor) gravar(CHAVE_VISTO, 1);
      dl({ event: 'conso_lead_modal_view', lead_braco: this.modo, lead_origem: origem });
    }

    fechar() {
      if (this.girando || !this.dialog.open) return;
      this.dialog.close();
      if (this.editor) return;
      const cupom = ler(CHAVE_CUPOM);
      this.mostrarAba(!!cupom);
      if (!cupom) dl({ event: 'conso_lead_modal_fechar', lead_braco: this.modo });
    }

    mostrarAba(comCupom) {
      const aba = this.config.aba || {};
      this.aba.querySelector('[data-lead-aba-texto]').textContent = comCupom ? aba.depois : aba.antes;
      this.aba.hidden = false;
    }

    // --- Form ---------------------------------------------------------------

    mascaraTelefone(v) {
      const d = v.replace(/\D/g, '').replace(/^55(?=\d{10,11}$)/, '').slice(0, 11);
      if (d.length <= 2) return d.length ? `(${d}` : '';
      if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
      if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
      return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
    }

    mascaraData(v) {
      const d = v.replace(/\D/g, '').slice(0, 8);
      if (d.length <= 2) return d;
      if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
      return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
    }

    // dd/mm/aaaa -> aaaa-mm-dd, ou null se não for uma data real e plausível (mesma
    // regra do cadastro da Área de membros e do app).
    dataIso(v) {
      const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(v || '');
      if (!m) return null;
      const [dia, mes, ano] = [+m[1], +m[2], +m[3]];
      const dt = new Date(ano, mes - 1, dia);
      if (dt.getFullYear() !== ano || dt.getMonth() !== mes - 1 || dt.getDate() !== dia) return null;
      const hoje = new Date();
      if (ano < 1900 || dt > new Date(hoje.getFullYear() - 12, hoje.getMonth(), hoje.getDate())) return null;
      return `${m[3]}-${m[2]}-${m[1]}`;
    }

    erro(campo, msg) {
      const p = this.querySelector(`[data-erro-para="${campo}"]`);
      if (p) p.textContent = msg;
      const input = this.form.elements[campo];
      if (input && input.setAttribute) input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }

    validar() {
      const f = this.form.elements;
      const nome = f.nome.value.trim().replace(/\s+/g, ' ');
      const email = f.email.value.trim().toLowerCase();
      const digitos = f.telefone.value.replace(/\D/g, '');
      let ok = true;
      if (nome.length < 2) {
        this.erro('nome', 'Informe seu nome.');
        ok = false;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        this.erro('email', 'Informe um e-mail válido.');
        ok = false;
      }
      if (digitos.length < 10 || digitos.length > 11) {
        this.erro('telefone', 'Informe DDD + número.');
        ok = false;
      }
      const nascimento = this.dataIso(f.nascimento.value.trim());
      if (!nascimento) {
        this.erro('nascimento', 'Use o formato dd/mm/aaaa.');
        ok = false;
      }
      if (!ok) {
        const primeiro = this.form.querySelector('[aria-invalid="true"]');
        if (primeiro) primeiro.focus();
        return null;
      }
      return { nome, email, telefone: digitos, nascimento, empresa: f.empresa.value };
    }

    async enviar() {
      if (this.form.classList.contains('is-enviando') || this.girando) return;
      this.erroGeral.textContent = '';
      const dados = this.validar();
      if (!dados) return;

      // Sorteio antes do envio: o prêmio vai junto pro log do app.
      const indice = this.modo === 'roleta' ? this.sortear() : -1;
      const premio = this.modo === 'roleta' ? this.config.premios[indice] : this.config.cupom;

      this.form.classList.add('is-enviando');
      this.cta.disabled = true;
      dl({ event: 'conso_lead_modal_submit', lead_braco: this.modo });

      if (!this.editor) {
        try {
          const ctrl = new AbortController();
          const timer = setTimeout(() => ctrl.abort(), 12000);
          const resp = await fetch(this.dataset.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(
              Object.assign({}, dados, {
                braco: this.modo,
                premio: premio ? premio.rotulo : '',
                pagina: this.dataset.pagina || location.pathname,
                aceite_versao: (this.querySelector('[data-aceite-versao]') || {}).dataset?.aceiteVersao || '',
              }),
            ),
            signal: ctrl.signal,
          });
          clearTimeout(timer);

          // Só trava com resposta do nosso app (campo/mensagem). 400 sem corpo vem do
          // proxy (rota fora do ar) e cai no caminho de falha: segue pro cupom.
          const corpo = resp.status === 400 || resp.status === 429 ? await resp.json().catch(() => ({})) : {};
          if (corpo.campo || corpo.mensagem) {
            this.form.classList.remove('is-enviando');
            this.cta.disabled = false;
            if (corpo.campo && this.form.elements[corpo.campo]) this.erro(corpo.campo, corpo.mensagem || 'Confira este campo.');
            else this.erroGeral.textContent = corpo.mensagem || 'Confira os dados e tente de novo.';
            return;
          }
          if (!resp.ok) console.warn('[conso-lead-modal] backend respondeu', resp.status);
        } catch (e) {
          console.warn('[conso-lead-modal] falha ao enviar o lead', e);
        }
      }

      const resultado = {
        codigo: premio && premio.codigo ? premio.codigo : '',
        rotulo: premio ? premio.rotulo : '',
        modo: this.modo,
        em: Date.now(),
      };
      if (!this.editor) {
        gravar(CHAVE_CUPOM, resultado);
        this.marcarCarrinho(resultado);
      }

      if (this.modo === 'roleta') {
        this.girando = true;
        this.dialog.classList.add('is-girando');
        await this.girar(indice);
        this.girando = false;
        this.dialog.classList.remove('is-girando');
      }

      this.form.classList.remove('is-enviando');
      this.cta.disabled = false;
      this.mostrarResultado(resultado, true);
      dl({ event: 'conso_lead_modal_premio', lead_braco: this.modo, lead_premio: resultado.rotulo });
    }

    // Marca o carrinho de quem passou pela roleta. Atributo com "_" não aparece pro
    // cliente no checkout, mas vai pro pedido (customAttributes / note_attributes): é o
    // que liga a compra à roleta, junto com a tag lead-popup-roleta no cliente.
    // fetch direto no /cart/update.js: não dispara evento do tema, a sacola não abre.
    marcarCarrinho(r) {
      if (!r || r.modo !== 'roleta') return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _conso_roleta: '1', _conso_roleta_premio: r.rotulo || '' } }),
      })
        .then((resp) => {
          if (resp.ok) sessionStorage.setItem(CHAVE_SESSAO_CARRINHO, '1');
        })
        .catch((e) => console.warn('[conso-lead-modal] falha ao marcar o carrinho', e));
    }

    // --- Resultado ----------------------------------------------------------

    mostrarResultado(r, foco) {
      const cfg = this.config.resultado || {};
      const temCupom = !!r.codigo;
      this.querySelector('[data-lead-etapa="form"]').hidden = true;
      this.querySelector('[data-lead-etapa="resultado"]').hidden = false;
      this.querySelector('[data-lead-res-titulo]').textContent = temCupom
        ? (cfg.titulo || '').replace('{premio}', r.rotulo)
        : cfg.semPremioTitulo;
      this.querySelector('[data-lead-res-texto]').textContent = temCupom ? cfg.texto : cfg.semPremioTexto;
      this.querySelector('[data-lead-res-codigo-box]').hidden = !temCupom;
      this.querySelector('[data-lead-res-codigo]').textContent = r.codigo;
      if (foco) {
        const copiar = this.querySelector('[data-lead-copiar]');
        if (temCupom && copiar) copiar.focus();
      }
    }

    async copiar(botao) {
      const codigo = this.querySelector('[data-lead-res-codigo]').textContent;
      try {
        await navigator.clipboard.writeText(codigo);
      } catch (e) {
        const sel = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.querySelector('[data-lead-res-codigo]'));
        sel.removeAllRanges();
        sel.addRange(range);
      }
      botao.textContent = 'Copiado!';
      dl({ event: 'conso_lead_modal_copiar', lead_braco: this.modo });
      setTimeout(() => (botao.textContent = 'Copiar'), 2000);
    }
  }

  customElements.define('conso-lead-modal', ConsoLeadModal);
})();
